export default __webpack_public_path__ + "static/media/2_0070.b36e5ded.webp";